import { render, staticRenderFns } from "./updHsnp.vue?vue&type=template&id=85e01a44&scoped=true"
import script from "./updHsnp.vue?vue&type=script&lang=js"
export * from "./updHsnp.vue?vue&type=script&lang=js"
import style0 from "./updHsnp.vue?vue&type=style&index=0&id=85e01a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e01a44",
  null
  
)

export default component.exports